export default __webpack_public_path__ + "favicon-72-b6e7852c659e565d82760a0e869738e9.bundle.png";